<template>
  <Enterprise_index></Enterprise_index>
  <Enterprise_page></Enterprise_page>
  <Footer></Footer>
</template>

<script>
import Enterprise_index from "@/components/CN/enterprise/Enterprise_index";
import Enterprise_page from "@/components/CN/enterprise/Enterprise_page";
import Footer from "@/components/CN/Footer";
import Header from '../../components/CN/Header'
export default {
  name: 'Enterprise',
  components: {Enterprise_page, Enterprise_index,Footer, Header},
}

</script>